module.exports = require("@mui/material/Dialog");